// extracted by mini-css-extract-plugin
export var aiStarIcon = "_k7-2";
export var container = "_k7-4";
export var dismissButton = "_k7-3";
export var hasPaddingBottom = "_k7-6";
export var last = "_k7-e";
export var scrollbarThumb = "_k7-c";
export var scrollbarTrack = "_k7-b";
export var selected = "_k7-9";
export var spin = "_k7-1";
export var spinning = "_k7-0";
export var suggestionItem = "_k7-d";
export var suggestionsPanel = "_k7-5";
export var tonePill = "_k7-8";
export var tonesContainer = "_k7-7";
export var unselected = "_k7-a";